import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { isCompleteCityOrSettlement } from '@sravni/cosago-react-library/lib/validationSchemes';
import { useCallback } from 'react';

import { useGetSeparateAddressesAutocomplete } from 'shared/api/daData/dadata.query';
import type { TDataCity } from 'shared/types/TUserAddressFields';

import { CommonAddressField } from '../CommonAddressField/CommonAddressField';

type Props = IFieldFactoryProps & {
  initialValue?: Nullable<Dictionaries.TSelectValue<string, TDataCity>>;
  onInitialSuggestsLoad?: (option: Dictionaries.TSelectOption<string, TDataCity>) => void;
};

export const CityAddressField: FC<Props> = (props) => {
  const { initialValue, onInitialSuggestsLoad, ...other } = props;
  const handleOnHide = (newValue: Nullable<Dictionaries.TSelectValue>) =>
    isCompleteCityOrSettlement(newValue?.data?.city_fias_id, newValue?.data?.settlement_fias_id);
  const [getSeparateAddressesAutocomplete] = useGetSeparateAddressesAutocomplete();

  const getCityAddress = useCallback(
    async (search: string) => {
      const response = await getSeparateAddressesAutocomplete(
        {
          query: search,
        },
        true,
      );

      return response.data || [];
    },
    [getSeparateAddressesAutocomplete],
  );

  return (
    <CommonAddressField
      {...other}
      getAddress={getCityAddress}
      handleOnHide={handleOnHide}
      initialValue={initialValue}
      onInitialSuggestsLoad={onInitialSuggestsLoad}
    />
  );
};
